<template>
  <div v-if="showTip" class="messagePage_layout">
    <div class="messagePage_layout_view">
      <div class="messagePage_layout_view_icon">
        <img
          src="../../../static/images/vip_discounts/message.png"
          alt=""
          width="100%"
        />
      </div>
      <div class="messagePage_layout_view_title">
        请在移动端打开链接
      </div>
    </div>
  </div>
</template>
<script>
import { isMobileDevice, isMobileOnlyEnabled } from "@/static/js/device.js";
export default {
  data() {
    return {
      showTip: false,
    };
  },
  created() {
    this.checkDevice();
  },
  methods: {
    /** 校验访问设备：开关关闭或本身是移动端时直接回首页，避免误拦截 */
    checkDevice() {
      if (!isMobileOnlyEnabled() || isMobileDevice()) {
        this.$router.replace({
          name: "Home",
          params: {},
        });
        return;
      }
      this.showTip = true;
    },
  },
};
</script>
<style scoped lang="less">
.messagePage_layout {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  &_view {
    text-align: center;
    &_icon {
      width: 200px;
      margin: 0 auto;
      padding: 20% 0px 36px;
    }
    &_title {
      font-size: 28px;
    }
  }
}
</style>
